export const text =
  '【5 月 18 号】TiDB 地区交流活动（北京站）！和社区大咖们聊聊全球视野下的 TiDB 应用实践！如何做到成本、效率两手抓！';
export const link = 'https://asktug.com/t/topic/1025166';
